import React, { useState, useEffect } from "react";
// componentes
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
import Select from "react-select";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ModalGoBackFunction from "./ModalGoBackFunction";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// redux
import { connect } from "react-redux";
// service
import { updateMenu } from "../../../utils/services/menus";
import { getGroups } from "../../../utils/services/group";
import {
  getCurrency,
  getCurrencyEvent,
  postCurrencyEvent,
} from "../../../utils/services/currency";
import { getUrlFiles } from "../../../utils/services/files";

function NewMenu(props) {
  const { isOpen, toggle } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  // dados do form
  const [url, setUrl] = useState(props.editMenu.linkUrl);
  const [name, setName] = useState(props.editMenu.nameExhibition);
  const [isVisible, setIsVisible] = useState(
    props.editMenu.isVisible ? true : false,
  );
  const [isEmbeded, setIsEmbeded] = useState(
    props.editMenu.isEmbeded ? true : false,
  );
  // campos do botão AR
  const [videoUrl, setVideoUrl] = useState(props.editMenu.videora || "");
  const [position, setPosition] = useState(props.editMenu.positionra || "");
  //confirmação
  const [successDlg, setSuccessDlg] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  //state de grupos
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState(false);

  //state de grupos selecionados
  const [groupsMulti, setGroupsMulti] = useState([]);

  const [currency, setCurrency] = useState([]);
  const [currencyEvent, setCurrencyEvent] = useState([]);
  const [allCurrency, setAllCurrency] = useState(false);
  const [currencyMulti, setCurrencyMulti] = useState([]);

  //state de erros
  const [urlErro, setUrlErro] = useState("");
  const [nameExErro, setNameExErro] = useState("");
  const [imageErro, setImageErro] = useState("");
  // Erros da edição do botão AR (não apagar)
  const [videoUrlErro, setVideoUrlErro] = useState("");
  const [imageMarcationErro, setImageMarcationErro] = useState("");
  const [positionErro, setPositionErro] = useState("");
  const [currencyError, setCurrencyError] = useState("");

  //icone
  const [imageView, setImageView] = useState(props.editMenu.backgroundImage);
  const [icon, setIcon] = useState(null);
  // state do preview da imagem da marcação (não apagar)
  const [imageMarcationView, setImageMarcationView] = useState(
    props.editMenu.imagemarker,
  );
  const [marcationIcon, setMarcationIcon] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // check
  const [separateText, setSeparateText] = useState(
    props.editMenu.textSeparator ?? false,
  );
  // cor do texto
  const [colorText, setColorText] = useState(
    props.editMenu.fontColor ?? "#fff",
  );
  // remover topo
  const [hideHeader, setHideHeader] = useState(
    props.editMenu.hideHeader ?? false,
  );
  // cor do topo
  const [headerColorEnabled, setHeaderColorEnabled] = useState(
    !!props.editMenu.headerColor,
  );
  const [headerColor, setHeaderColor] = useState(
    props.editMenu.headerColor ?? "#000000",
  );

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // controla a seleção de grupos, tratando a opção "TODOS" como exclusiva
  function handleGroupMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllGroups(true);
    } else {
      setAllGroups(false);
    }
    setGroupsMulti(a);
  }

  // controla a seleção de moedas, tratando a opção "TODOS" como exclusiva
  function handleCurrencyMulti(a) {
    const length = a.length - 1;
    if (a[length]?.value === "todos") {
      setCurrencyMulti([a[length]]);
      setAllCurrency(true);
    } else {
      setCurrencyMulti(a);
      setAllCurrency(false);
    }
    setCurrencyError("");
  }

  // lê o arquivo de imagem selecionado e atualiza o preview
  const onImageChange = (event, setStateFunction) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setStateFunction(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  // valida o form, envia as novas imagens (se houver) e atualiza o botão
  async function submitForm(e) {
    e.preventDefault();

    if (!props.editMenu.isDefault) {
      if (url === "") {
        setUrlErro("O campo URL é obrigatório.");
        return;
      } else setUrlErro("");
    }

    if (name === "") {
      setNameExErro("O campo Nome de Exibição é obrigatório.");
      return;
    } else setNameExErro("");

    let iconFile =
      imageView === props.editMenu.backgroundImage ? imageView : icon?.files[0];

    if (iconFile === undefined) {
      setImageErro("O campo Ícone é obrigatório.");
      return;
    } else setImageErro("");

    if (props.editMenu.isDefault) {
      if (props.editMenu.linkUrl === "CURRENCYCONVERTER") {
        if (currencyMulti.length < 2) {
          setCurrencyError("É necessário selecionar mais de uma moeda.");
          return;
        } else {
          setCurrencyError("");
        }
      }

      //Erros ao editar campo default AR (não apagar)
      if (props.editMenu.linkUrl === "AR") {
        if (videoUrl === "") {
          setVideoUrlErro("O campo URL do vídeo é obrigatório.");
          return;
        } else setVideoUrlErro("");
      }
    }

    let marcationIconFile = null;
    if (props.editMenu.isDefault && props.editMenu.linkUrl === "AR") {
      marcationIconFile =
        imageMarcationView === props.editMenu.imagemarker
          ? imageMarcationView
          : marcationIcon?.files[0];

      if (marcationIconFile === undefined) {
        setImageMarcationErro("O campo Imagem da Marcação é obrigatório.");
        return;
      } else setImageMarcationErro("");

      if (position === "") {
        setPositionErro("O campo Posição é obrigatório.");
        return;
      } else setPositionErro("");
    }

    setIsLoading(true);

    //array de grupos
    const groupsArray = [];

    if (allGroups) {
      groups.forEach((e) => {
        groupsArray.push({ grupo: e.id });
      });
    } else {
      groupsMulti.forEach((e) => {
        groupsArray.push({ grupo: e.value });
      });
    }

    let urlImg = props.editMenu.backgroundImage;
    let urlImgMarker = props.editMenu.imagemarker;
    let expireDate = props.editMenu.expireDate;
    let expireDateRa = props.editMenu.expireDateRa;

    if (
      imageView !== props.editMenu.backgroundImage ||
      imageMarcationView !== props.editMenu.imagemarker
    ) {
      const data = new FormData();
      if (iconFile instanceof File) data.append("files", iconFile);
      if (marcationIconFile instanceof File)
        data.append("files", marcationIconFile);
      data.append("folder", "menu");
      data.append("eventId", props.idEvent);

      try {
        const response = await getUrlFiles(
          data,
          props.state.global_user_data.data.token,
        );
        response.forEach((file) => {
          if (file.name === icon?.files[0]?.name && iconFile instanceof File) {
            urlImg = file.url;
            expireDate = file.expires;
          }
          if (
            file.name === marcationIcon?.files[0]?.name &&
            marcationIconFile instanceof File
          ) {
            urlImgMarker = file.url;
            expireDateRa = file.expires;
          }
        });
      } catch (error) {
        console.error("Erro ao enviar a imagem:", error);
        setSubmitErrorMessage("Erro ao enviar a imagem.");
        setIsLoading(false);
        return;
      }
    }

    const objButton = {
      order: props.editMenu.order,
      columnSize: 1,
      description: props.editMenu.description,
      nameExhibition: name,
      textSeparator: separateText,
      fontColor: colorText ?? "#000000",
      backgroundColor: "#fff",
      typeBtn: "default",
      linkUrl: !props.editMenu.isDefault ? url : props.editMenu.linkUrl,
      isEmbeded: isEmbeded,
      isVisible: isVisible,
      grupos: groupsArray,
      menuId: props.idButton,
      isDefault: props.editMenu.isDefault,
      id: props.editMenu.id,
      videora: props.editMenu.linkUrl === "AR" ? videoUrl : null,
      positionra: props.editMenu.linkUrl === "AR" ? position : null,
      backgroundImage: urlImg,
      imagemarker: urlImgMarker,
      expireDate: expireDate,
      expireDateRa: expireDateRa,
      hideHeader: hideHeader,
      headerColor: headerColorEnabled && !hideHeader ? headerColor : null,
    };

    try {
      const menuData = await updateMenu(
        objButton,
        props.state.global_user_data.data.token,
      );

      if (menuData.message === "BUTTON_UPDATED") {
        setSuccessDlg(true);

        //set currency event
        if (
          props.editMenu.isDefault === true &&
          props.editMenu.linkUrl === "CURRENCYCONVERTER"
        ) {
          const currencyArray = [];

          if (allCurrency) {
            currency.forEach((e) => {
              currencyArray.push(e.id);
            });
          } else {
            currencyMulti.forEach((e) => {
              currencyArray.push(e.value);
            });
          }
          const currencyData = {
            eventId: props.idEvent,
            currency: currencyArray,
          };

          try {
            await postCurrencyEvent(currencyData);
          } catch (error) {
            console.error("Erro ao salvar moedas do evento:", error);
            setSubmitErrorMessage("Erro ao salvar as moedas do evento.");
          }
        }
      } else {
        setSubmitErrorMessage("Erro ao editar o botão.");
      }
    } catch (error) {
      console.error("Erro ao editar o botão:", error);
      setSubmitErrorMessage("Erro ao editar o botão.");
    } finally {
      setIsLoading(false);
    }
  }

  // busca os grupos do evento para o select de segmentação
  async function getGroupsFunc() {
    try {
      const response = await getGroups({
        jwt: props.state.global_user_data.data.token,
        eventId: props.idEvent,
        offset: 1,
        limit: 0,
        search: "",
      });
      setGroups(response.findOneGroupData.data);
    } catch (error) {
      console.error("Erro ao buscar grupos:", error);
      toast.error("Erro ao buscar grupos.");
    }
  }

  // busca a lista de moedas disponíveis
  async function getCurrencyList() {
    try {
      const response = await getCurrency();
      setCurrency(response.findAllCurrencyData.data);
    } catch (error) {
      console.error("Erro ao buscar moedas:", error);
      toast.error("Erro ao buscar moedas.");
    }
  }

  // busca as moedas já configuradas para o evento
  async function getCurrencyByEvent() {
    try {
      const response = await getCurrencyEvent({
        eventId: props.idEvent,
      });
      setCurrencyEvent(response.findByEventData.data);
    } catch (error) {
      console.error("Erro ao buscar moedas do evento:", error);
      toast.error("Erro ao buscar moedas do evento.");
    }
  }

  // monta a lista de grupos já selecionados para este botão
  function funcGroups() {
    let groupsArray = [];
    if (groups?.length > 0) {
      props.editMenu.grupos
        ?.filter((e) => e.enabled === true)
        .forEach((a) => {
          groupsArray.push({ label: a.grupo.name, value: a.grupo.id });
        });
      if (groups?.length === groupsArray.length) {
        groupsArray = [];
        groupsArray.push({ label: "TODOS", value: "todos" });
        setAllGroups(true);
      }
    }
    setGroupsMulti(groupsArray);
  }

  // monta a lista de moedas já selecionadas para este evento
  function funcCurrency() {
    let currencyArray = [];
    if (currency?.length > 0) {
      currencyEvent.forEach((a) => {
        currencyArray.push({ label: a.name, value: a.currencyId });
      });
      if (currency?.length === currencyArray.length) {
        currencyArray = [];
        currencyArray.push({ label: "TODOS", value: "todos" });
        setAllCurrency(true);
      }
    }

    setCurrencyMulti(currencyArray);
  }

  useEffect(() => {
    getGroupsFunc();
    getCurrencyByEvent();
    getCurrencyList();
  }, []);

  useEffect(() => {
    funcGroups();
  }, [groups]);

  useEffect(() => {
    funcCurrency();
  }, [currency, currencyEvent]);

  const getCurrencyOptions = () => {
    const selectedIds = currencyMulti?.map((item) => item.value) || [];

    let filtered = currency.filter((item) => !selectedIds.includes(item.id));

    if (selectedIds.includes("todos")) {
      filtered = [];
    }

    return [
      { label: "TODOS", value: "todos" },
      ...filtered.map((e) => ({ label: e.name + ` (${e.code})`, value: e.id })),
    ];
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      {successDlg ? (
        <SweetAlert
          success
          title={"Editado"}
          onConfirm={() => {
            props.getAllMenus();
            setSuccessDlg(false);
            toggle();
          }}
        >
          {"Botão editado com sucesso!"}
        </SweetAlert>
      ) : null}
      {submitErrorMessage && (
        <SweetAlert
          danger
          title={"Erro"}
          onConfirm={() => setSubmitErrorMessage("")}
        >
          {submitErrorMessage}
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Editar Botão</ModalHeader>
      <ModalBody>
        <form onSubmit={submitForm}>
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">ID do Botão</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editMenu.id}
                  disabled
                />
              </div>
            </Col>
          </Row>

          {props.editMenu.isDefault === false && (
            <div>
              <Row>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Nome</label>
                    <input
                      readOnly
                      className="form-control"
                      type="text"
                      defaultValue={props.editMenu.description}
                      disabled
                    />
                  </div>
                </Col>
              </Row>

              <Row style={{ paddingTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">URL*</label>
                    <input
                      className="form-control"
                      type="text"
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                    />
                    <div>
                      <span style={{ fontWeight: "bold" }}>Importante:</span>{" "}
                      Caso a URL não tenha um parâmetro com ?, insira o
                      parâmetro ?enabled=true ao final da URL.
                    </div>
                    {urlErro && <span className="text-danger">{urlErro}</span>}
                  </div>
                </Col>
              </Row>
            </div>
          )}

          <Row style={{ paddingTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Nome de Exibição*</label>
                <input
                  className="form-control"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {nameExErro && (
                  <span className="text-danger">{nameExErro}</span>
                )}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
              <label
                htmlFor="formFile"
                className="form-label"
                style={{ marginBottom: 0 }}
              >
                Ícone*
              </label>
              <label htmlFor="inputImage" style={{ marginBottom: 0 }}>
                <i className="bx bx-pencil" style={{ cursor: "pointer" }} />
              </label>

              <input
                id="inputImage"
                type={"file"}
                onChange={(e) => {
                  setIcon(
                    e.target.files.length > 0
                      ? { files: e.target.files }
                      : null,
                  );
                  onImageChange(e, setImageView);
                }}
                style={{ display: "none" }}
              />
            </Col>

            <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
              <img alt="edit" src={imageView} style={{ width: 70 }} />
            </Col>
          </Row>
          {imageErro && <span className="text-danger">{imageErro}</span>}

          <Row style={{ paddingTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupos</label>
                <Select
                  value={groupsMulti}
                  placeholder={"Selecione"}
                  isMulti={true}
                  onChange={(e) => {
                    handleGroupMulti(e);
                  }}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  options={[
                    {
                      options:
                        groups?.length > 0 && !allGroups
                          ? [
                              { label: "TODOS", value: "todos" },
                              ...groups.map((e) => {
                                return { label: e.name, value: e.id };
                              }),
                            ]
                          : [],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
            {props.editMenu.isDefault === true &&
              props.editMenu.linkUrl === "CURRENCYCONVERTER" && (
                <Col lg={12}>
                  <div style={{ marginTop: "10px" }}>
                    <label className="form-label">Moedas *</label>
                    <Select
                      value={currencyMulti}
                      placeholder={"Selecione"}
                      isMulti={true}
                      onChange={(e) => handleCurrencyMulti(e)}
                      options={[{ options: getCurrencyOptions() }]}
                      classNamePrefix="select2-selection"
                    />
                  </div>
                  {currencyError && (
                    <span className="text-danger">{currencyError}</span>
                  )}
                </Col>
              )}
          </Row>

          <Row className="gy-4" style={{ marginTop: 20, marginBottom: 20 }}>
            <Col md={6}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkVisible"
                  checked={isVisible}
                  onChange={(e) => setIsVisible(e.target.checked)}
                />
                <label htmlFor="checkVisible">Visível</label>
              </div>
            </Col>

            {props.editMenu.isDefault === false && (
              <Col md={6}>
                <div className="form-check form-check-end">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="checkExternal"
                    checked={isEmbeded}
                    onChange={(e) => setIsEmbeded(e.target.checked)}
                  />
                  <label htmlFor="checkExternal">Externo</label>
                </div>
              </Col>
            )}
          </Row>
          {props.editMenu.isDefault && props.editMenu.linkUrl === "AR" && (
            <>
              <Row style={{ paddingTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label htmlFor="video-url" className="form-label">
                      URL do vídeo*
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="video-url"
                      value={videoUrl}
                      onChange={(e) => setVideoUrl(e.target.value)}
                    />
                    {videoUrlErro && (
                      <span className="text-danger">{videoUrlErro}</span>
                    )}
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
                  <label
                    htmlFor="formFile"
                    className="form-label"
                    style={{ marginBottom: 0 }}
                  ></label>
                  Imagem da Marcação*
                  <label
                    htmlFor="inputMarcationImage"
                    style={{ marginBottom: 0 }}
                  >
                    <i className="bx bx-pencil" style={{ cursor: "pointer" }} />
                  </label>
                  <input
                    id="inputMarcationImage"
                    type={"file"}
                    onChange={(e) => {
                      setMarcationIcon(
                        e.target.files.length > 0
                          ? { files: e.target.files }
                          : null,
                      );
                      onImageChange(e, setImageMarcationView);
                    }}
                    style={{ display: "none" }}
                  />
                </Col>

                <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    alt="Imagem da Marcação"
                    src={imageMarcationView}
                    style={{ width: 70 }}
                  />
                </Col>
              </Row>
              {imageMarcationErro && (
                <span className="text-danger">{imageMarcationErro}</span>
              )}
              <Row style={{ paddingTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Posição*</label>
                    <input
                      className="form-control"
                      type="text"
                      value={position}
                      onChange={(e) => setPosition(e.target.value)}
                    />
                    {positionErro && (
                      <span className="text-danger">{positionErro}</span>
                    )}
                  </div>
                </Col>
              </Row>
            </>
          )}

          <Row style={{ marginTop: 20 }}>
            <Col md={6}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkText"
                  checked={separateText}
                  onChange={(e) => setSeparateText(e.target.checked)}
                />
                <label htmlFor="checkText">
                  Separar Texto da Imagem (Menu)
                </label>
              </div>
            </Col>

            {separateText && (
              <Col md={6}>
                <ColorPicker
                  classOfContainer="primary-card-pickr"
                  setStateFunc={setColorText}
                  defaultColor={colorText}
                  labelText="Cor do Texto *"
                  idDiv="corTexto"
                  noMargin={true}
                />
              </Col>
            )}
          </Row>

          {!hideHeader && (
            <Row style={{ marginTop: 20 }}>
              <Col md={6}>
                <div className="form-check form-check-end">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="checkHeaderColor"
                    checked={headerColorEnabled}
                    onChange={(e) => setHeaderColorEnabled(e.target.checked)}
                  />
                  <label htmlFor="checkHeaderColor">
                    Alterar Cor do Topo e Ícones
                  </label>
                </div>
              </Col>

              {headerColorEnabled && (
                <Col md={6}>
                  <ColorPicker
                    classOfContainer="menu-header-color-pickr"
                    setStateFunc={setHeaderColor}
                    defaultColor={headerColor}
                    labelText="Cor do Topo *"
                    idDiv="corTopo"
                    noMargin={true}
                  />
                </Col>
              )}
            </Row>
          )}

          <Row style={{ marginTop: 20 }}>
            <Col md={12}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkHideHeader"
                  checked={hideHeader}
                  onChange={(e) => setHideHeader(e.target.checked)}
                />
                <label htmlFor="checkHideHeader">Remover Topo</label>
              </div>

              {hideHeader && (
                <div>
                  <span style={{ fontWeight: "bold" }}>Importante:</span>{" "}
                  <span>
                    Para não utilizar o voltar do aplicativo utilize o parâmetro
                    back_button=false e insira a função <ModalGoBackFunction />{" "}
                    na tela a ser embedada.
                  </span>
                </div>
              )}
            </Col>
          </Row>

          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: 10,
              }}
            >
              <Button
                color="success"
                className="btn btn-danger waves-effect waves-light"
                style={{ width: 80 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>
              <ButtonSpinner
                isLoading={isLoading}
                title={"Salvar"}
                marginLeft={10}
                action="U"
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(NewMenu);
